export const cashAmount = {
    state: {
        companiesCashAmount: null
    },
    mutations: {
        SET_COMPANIES_CASH_AMOUNT_DATA: (state, payload) => {
            state.companiesCashAmount = payload
        }
    },
    actions: {
        async fetchCashAmount({ commit, getters, dispatch }) {
            const requests = []
            const userId = getters.getUser.id
            const companiesCashAmountData = []

            !getters.getDevices && await dispatch('devicesFetch')

            getters.getDevices && getters.getDevices.forEach(device => {
                device && requests.push(this.$api.post('statistics/cashAmount', {
                    userId,
                    shopId: device.location_id
                }))
            })

            Promise.allSettled(requests).then(promises => {
                promises.forEach(promise => {
                    if(promise.status === 'fulfilled' && promise.value.data && promise.value.data.data) companiesCashAmountData.push(...promise.value.data.data)
                })

                commit('SET_COMPANIES_CASH_AMOUNT_DATA', companiesCashAmountData)
            })
        }
    },
    getters: {
        getCompaniesCashAmount(state) {
            return state.companiesCashAmount
        }
    }
}